/* eslint-disable no-restricted-imports */
import router from 'next/router';

export const removePromoCodeQuery = (parkingRedirectUrl: string) => {
	delete router.query.promocode;
	delete router.query.offerid;
	router.push(parkingRedirectUrl, undefined, { shallow: true });
};
